import './sidenav.scss';

import {
    Icon,
    LocalizedLink,
} from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import React, { useState } from 'react';

import SiteLocaleSelectionPopupMenu from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/SiteLocale/SiteLocaleSelectionPopupMenu';
import { uniqBy } from 'lodash';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useSignOutAction } from '@progymedia/gatsby-theme-boutik-ecommerce/src/context/customerAccount';
import { useTranslation } from 'react-i18next';

export default function Sidenav(props: {
    setSidenavOpen: any;
    categoryTypes: any;
    allCategories: any;
}) {
    const { setSidenavOpen, categoryTypes, allCategories } = props;
    const arrowIcon =
        'M0,11.024,4.768,6.246,0,1.468,1.468,0,7.714,6.246,1.468,12.492Z';
    const positionIcon =
        'M6.056,17.637C.948,10.232,0,9.472,0,6.75a6.75,6.75,0,0,1,13.5,0c0,2.722-.948,3.482-6.056,10.887a.844.844,0,0,1-1.387,0ZM6.75,9.562A2.812,2.812,0,1,0,3.937,6.75,2.812,2.812,0,0,0,6.75,9.562Z';
    const accountIcon =
        'M13.563,13.563A4.531,4.531,0,1,0,9.031,9.031,4.544,4.544,0,0,0,13.563,13.563Zm0,2.266c-3,0-9.062,1.529-9.062,4.531v2.266H22.625V20.359C22.625,17.358,16.564,15.828,13.563,15.828Z';
    const [isOpened, setIsOpened] = useState({
        appliance: false,
        venting: false,
        parts: false,
        service: false,
        contact: false,
    });
    const { t } = useTranslation('layout');
    const { currentLocale } = usePageLocalization();
    const isUSA = currentLocale === 'en_US';
    const [signOut] = useSignOutAction();

    return (
        <div className='sidenav-wrap container-100'>
            <div
                className='sidenav-row'
                onClick={() => {
                    setIsOpened({
                        ...isOpened,
                        appliance: !isOpened.appliance,
                    });
                }}
            >
                <span className={isOpened.appliance ? 'title opened' : 'title'}>
                    {t('navigation.appliances.appliances')}
                </span>
                <Icon
                    className={
                        isOpened.appliance ? 'control opened' : 'control'
                    }
                    d={arrowIcon}
                    size='18'
                    viewbox='0 0 12.492 7.714'
                    transform={
                        isOpened.appliance
                            ? 'translate(0 7.714) rotate(-90)'
                            : 'translate(12.492) rotate(90)'
                    }
                    color='white'
                />
                {isOpened.appliance && (
                    <ul className='links'>
                        <li>
                            <LocalizedLink
                                className='link'
                                onClick={() => setSidenavOpen(false)}
                                to='/wood-fireplaces/'
                            >
                                {t('navigation.appliances.fireplaces')}
                            </LocalizedLink>
                        </li>
                        <li>
                            <LocalizedLink
                                className='link'
                                onClick={() => setSidenavOpen(false)}
                                to='/stoves/'
                            >
                                {t('navigation.appliances.stoves')}
                            </LocalizedLink>
                        </li>
                        <li>
                            <LocalizedLink
                                className='link'
                                onClick={() => setSidenavOpen(false)}
                                to='/wood-inserts/'
                            >
                                {t('navigation.appliances.inserts')}
                            </LocalizedLink>
                        </li>
                    </ul>
                )}
            </div>

            {!isUSA && (
                <div
                    className='sidenav-row'
                    onClick={() => {
                        setIsOpened({
                            ...isOpened,
                            venting: !isOpened.venting,
                        });
                    }}
                >
                    <span
                        className={isOpened.venting ? 'title opened' : 'title'}
                    >
                        {t('navigation.ventings-chimney.ventings-chimney')}
                    </span>
                    <Icon
                        className={
                            isOpened.venting ? 'control opened' : 'control'
                        }
                        d={arrowIcon}
                        size='18'
                        viewbox='0 0 12.492 7.714'
                        transform={
                            isOpened.venting
                                ? 'translate(0 7.714) rotate(-90)'
                                : 'translate(12.492) rotate(90)'
                        }
                        color='white'
                    />
                    {isOpened.venting && (
                        <ul className='links'>
                            {categoryTypes.map(
                                (categoryType: any, index: number) => {
                                    const categoryNames = allCategories.filter(
                                        (category: any) =>
                                            category.id.includes(
                                                categoryTypes[index]?.type
                                            )
                                    );
                                    const uniqueCategories = uniqBy(
                                        categoryNames,
                                        'name'
                                    ).sort((a: any, b: any) =>
                                        a.name > b.name ? 1 : -1
                                    );
                                    return (
                                        <li key={index}>
                                            <LocalizedLink
                                                className='link'
                                                onClick={() =>
                                                    setSidenavOpen(false)
                                                }
                                                to={`/venting/?filter=${categoryType.url}&subfilter=${uniqueCategories?.[0]?.url_name}&diameter=none`}
                                            >
                                                {categoryType.type}
                                            </LocalizedLink>
                                        </li>
                                    );
                                }
                            )}
                        </ul>
                    )}
                </div>
            )}

            <div
                className='sidenav-row'
                onClick={() => {
                    setIsOpened({
                        ...isOpened,
                        parts: !isOpened.parts,
                    });
                }}
            >
                <span className={isOpened.parts ? 'title opened' : 'title'}>
                    {t('navigation.parts-accessories.parts-accessories')}
                </span>
                <Icon
                    className={isOpened.parts ? 'control opened' : 'control'}
                    d={arrowIcon}
                    size='18'
                    viewbox='0 0 12.492 7.714'
                    transform={
                        isOpened.parts
                            ? 'translate(0 7.714) rotate(-90)'
                            : 'translate(12.492) rotate(90)'
                    }
                    color='white'
                />
                {isOpened.parts && (
                    <ul className='links'>
                        <li>
                            <LocalizedLink
                                className='link'
                                onClick={() => setSidenavOpen(false)}
                                to='/archives/'
                            >
                                {t(
                                    'navigation.parts-accessories.replacement-part'
                                )}
                            </LocalizedLink>
                        </li>
                        <li>
                            <LocalizedLink
                                className='link'
                                onClick={() => setSidenavOpen(false)}
                                to='/accessories/'
                            >
                                {t('navigation.parts-accessories.accessories')}{' '}
                            </LocalizedLink>
                        </li>
                    </ul>
                )}
            </div>

            <div
                className='sidenav-row'
                onClick={() => {
                    setIsOpened({
                        ...isOpened,
                        service: !isOpened.service,
                    });
                }}
            >
                <span className={isOpened.service ? 'title opened' : 'title'}>
                    {t('navigation.service-support.service-support')}
                </span>
                <Icon
                    className={isOpened.service ? 'control opened' : 'control'}
                    d={arrowIcon}
                    size='18'
                    viewbox='0 0 12.492 7.714'
                    transform={
                        isOpened.service
                            ? 'translate(0 7.714) rotate(-90)'
                            : 'translate(12.492) rotate(90)'
                    }
                    color='white'
                />
                {isOpened.service && (
                    <ul className='links'>
                        <li>
                            <LocalizedLink
                                className='link'
                                onClick={() => setSidenavOpen(false)}
                                to='/articles/'
                            >
                                {t('navigation.service-support.faq')}
                            </LocalizedLink>
                        </li>
                        <li>
                            <LocalizedLink
                                className='link'
                                onClick={() => setSidenavOpen(false)}
                                to='/warranty/'
                            >
                                {t('navigation.service-support.warranty')}
                            </LocalizedLink>
                        </li>
                        <li>
                            <LocalizedLink
                                className='link'
                                onClick={() => setSidenavOpen(false)}
                                to='/gov-incentives/'
                            >
                                {t('navigation.service-support.gov-incentives')}
                            </LocalizedLink>
                        </li>
                        <li>
                            <LocalizedLink
                                className='link'
                                onClick={() => setSidenavOpen(false)}
                                to='/archives/'
                            >
                                {t('navigation.service-support.manuals')}
                            </LocalizedLink>
                        </li>
                        <li>
                            <LocalizedLink
                                className='link'
                                onClick={() => setSidenavOpen(false)}
                                to='/comparator/'
                            >
                                {t('navigation.service-support.comparator')}
                            </LocalizedLink>
                        </li>
                    </ul>
                )}
            </div>

            <div
                className='sidenav-row'
                onClick={() => {
                    setIsOpened({
                        ...isOpened,
                        contact: !isOpened.contact,
                    });
                }}
            >
                <LocalizedLink
                    className='link'
                    onClick={() => setSidenavOpen(false)}
                    to='/contact/'
                >
                    <span className='title'>{t('navigation.contact-us')}</span>
                </LocalizedLink>
            </div>

            {!isUSA && (
                <div className='sidenav-row'>
                    <LocalizedLink
                        className='link'
                        onClick={() => setSidenavOpen(false)}
                        to='/find-retailer/'
                    >
                        <Icon
                            className='sidenav-row-icon'
                            d={positionIcon}
                            size='18'
                            viewbox='0 0 13.5 18'
                            transform='translate(0 0)'
                            color='white'
                        />

                        <span>{t('quick-retailer.find-retailer')}</span>
                    </LocalizedLink>
                </div>
            )}

            <div className='sidenav-row'>
                <LocalizedLink className='link' to='/account/my-account/'>
                    <Icon
                        className='sidenav-row-icon'
                        d={accountIcon}
                        size='18'
                        viewbox='0 0 18.125 18.125'
                        transform='translate(-4.5 -4.5)'
                        color='white'
                    />
                    <span>{t('account.myaccount')}</span>
                </LocalizedLink>
            </div>

            <div className='sidenav-row'>
                <LocalizedLink
                    onClick={() => {
                        signOut();
                        setSidenavOpen(false);
                    }}
                    className='link'
                    to='/account/my-account/'
                >
                    <span>{t('account.logout')}</span>
                </LocalizedLink>
            </div>

            <div className='sidenav-row'>
                <div className='languageSelector'>
                    <SiteLocaleSelectionPopupMenu showCurrency={true} />
                </div>
            </div>
        </div>
    );
}
